<script setup lang="ts">
import DefaultButton from "@/components/Buttons/DefaultButton.vue";

type Props = {
  unreadCount: number;
};

type Emits = {
  (e: "markAllRead"): void;
};

defineProps<Props>();
const emit = defineEmits<Emits>();
</script>

<template>
  <div class="mb-4 flex items-center justify-between">
    <h2 class="text-xl font-bold dark:text-slate-200">
      {{ $t("notifications.title") }}
    </h2>
    <DefaultButton
      v-if="unreadCount > 0"
      color="yellow"
      size="small"
      class="mx-0!"
      @click="emit('markAllRead')"
    >
      <span>{{ $t("notifications.mark_all_as_read") }}</span>
    </DefaultButton>
  </div>
</template>
